export const GET_EMAILS_REQUEST = 'app/services/Emails/GET_EMAILS_REQUEST';
export const GET_EMAILS_SUCCESS = 'app/services/Emails/GET_EMAILS_SUCCESS';
export const GET_EMAILS_FAILURE = 'app/services/Emails/GET_EMAILS_FAILURE';
export const POST_EMAILS_REQUEST = 'app/services/Emails/POST_EMAILS_REQUEST';
export const POST_EMAILS_SUCCESS = 'app/services/Emails/POST_EMAILS_SUCCESS';
export const POST_EMAILS_FAILURE = 'app/services/Emails/POST_EMAILS_FAILURE';
export const DELETE_EMAILS_REQUEST = 'app/services/Emails/DELETE_EMAILS_REQUEST';
export const DELETE_EMAILS_SUCCESS = 'app/services/Emails/DELETE_EMAILS_SUCCESS';
export const DELETE_EMAILS_FAILURE = 'app/services/Emails/DELETE_EMAILS_FAILURE';
export const PUT_EMAILS_REQUEST = 'app/services/Emails/PUT_EMAILS_REQUEST';
export const PUT_EMAILS_SUCCESS = 'app/services/Emails/PUT_EMAILS_SUCCESS';
export const PUT_EMAILS_FAILURE = 'app/services/Emails/PUT_EMAILS_FAILURE';

export const actionGetEmailsRequest = () => ({
    type: GET_EMAILS_REQUEST,
});

export const actionGetEmailsSuccess = (data) => ({
    type: GET_EMAILS_SUCCESS,
    payload: data,
});

export const actionGetEmailsFailure = (error) => ({
    type: GET_EMAILS_FAILURE,
    error,
});

export const actionDeleteEmailsRequest = () => ({
    type: DELETE_EMAILS_REQUEST,
});

export const actionDeleteEmailsSuccess = (data) => ({
    type: DELETE_EMAILS_SUCCESS,
    payload: data,
});

export const actionDeleteEmailsFailure = (error) => ({
    type: DELETE_EMAILS_FAILURE,
    error,
});

export const actionPutEmailsRequest = () => ({
    type: DELETE_EMAILS_REQUEST,
});

export const actionPutEmailsSuccess = (data) => ({
    type: DELETE_EMAILS_SUCCESS,
    payload: data,
});

export const actionPutEmailsFailure = (error) => ({
    type: DELETE_EMAILS_FAILURE,
    error,
});

export const actionPostEmailsRequest = () => ({
    type: POST_EMAILS_REQUEST,
});

export const actionPostEmailsSuccess = (data) => ({
    type: POST_EMAILS_SUCCESS,
    payload: data,
});

export const actionPostEmailsFailure = (error) => ({
    type: POST_EMAILS_FAILURE,
    error,
});
